import { useMutation } from "@tanstack/react-query";
import { fetchWorkInfo, WorkInfoStatus } from "@/services/api";

import { vipModalShowAtom } from "@/atom/user";
import { message } from "@/components/Toast";
import Modal from "@/components/Modal";

import { useSetAtom, useAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import {
  todayWorksAtom,
  workIdAtom,
  earlierWorksAtom,
  weekWorksAtom,
  topWorksAtom,
  workSelectedAtom,
} from "@/atom/drawBoard";
import { userInfoAtom } from "@/atom/user";

import { pushWorkItemTop } from "@/services/Course/courseApi";
import { deleteWork } from "@/services/api";

const useWork = () => {
  const setVipModalShow = useSetAtom(vipModalShowAtom);
  const setWorkId = useSetAtom(workIdAtom);
  const [workSelected, setWorkSelected] = useAtom(workSelectedAtom);
  const setTopWorks = useSetAtom(topWorksAtom);
  const setWeekWorks = useSetAtom(weekWorksAtom);
  const setTodayWorks = useSetAtom(todayWorksAtom);
  const setEarlierWorks = useSetAtom(earlierWorksAtom);
  let navigate = useNavigate();

  const mutationWorkInfo = useMutation({
    mutationFn: fetchWorkInfo,
    onSuccess: (data) => {
      const { workId, status, lessonId } = data?.data || {};
      if (setTodayWorks)
        setTodayWorks((preWorks: []) => [data?.data, ...preWorks]);
      // setWorkId(workId);

      //switch to the work created
      navigate(`/work?currentWorkId=${workId}`);
      setWorkSelected(data.data);
      setWorkId(workId);
      const url = new URL(window.location.href);
      url.searchParams.set("currentWorkId", workId);
      window.history.replaceState({}, "", url.toString());

      let msg;
      if (data.code !== 0) {
        Modal.show({
          title: `${data.msg || "出错了"}, 请重试`,
          confirmTxt: "确定",
          cancelTxt: "",
        });
        return;
      }
      switch (status) {
        case WorkInfoStatus.NoPermission:
          if (lessonId) {
            msg = "无权限，请先购买课程";
          } else {
            msg = "无权限，请开通或升级会员";
            setVipModalShow(true);
          }
          break;
        case WorkInfoStatus.LessonComplete:
          msg = "用户会员轮次已经用完，请开通更高级别会员继续创作";
          setVipModalShow(true);
          break;

        default:
          break;
      }
      if (msg) {
        message.info(msg);
        return;
      }
      // if (workId) {
      //   // window.open(`/course/?workId=${workId}`);
      //   setWorkId(workId);
      // }
    },
  });

  const add = () => {
    mutationWorkInfo.mutate({});
  };

  const filterWorks = (works: any) => {
    setTopWorks(() => []);
    setWeekWorks(() => []);
    setEarlierWorks(() => []);
    setTodayWorks(() => []);
    for (let i = 0; i < works.length; i++) {
      if (works[i].position === "top") {
        setTopWorks((preWorks: []) => [...preWorks, works[i]]);
      } else if (works[i].position === "week") {
        setWeekWorks((preWorks: []) => [...preWorks, works[i]]);
      } else if (works[i].position === "today") {
        setTodayWorks((preWorks: []) => [...preWorks, works[i]]);
      } else {
        setEarlierWorks((preWorks: []) => [...preWorks, works[i]]);
      }
    }
  };

  const makeWorkTop = async (work: any, isTop: Boolean) => {
    let result = await pushWorkItemTop(work?.workId, isTop);
    if (result?.code === 0 && result?.msg === "success") {
      filterWorks(result.data.works);
    }
  };

  const removeWork = async (workId: string) => {
    const isTheSelectedWork = workSelected.workId === workId;
    let result = await deleteWork({ workId: workId });
    console.log("data delelte:", result);
    if (result?.code === 0 && result?.msg === "success") {
      message.info("删除成功");
      filterWorks(result.data.works);
    } else {
      message.info("删除失败，请重试！");
    }

    if (!isTheSelectedWork) return;

    if (result.data.works.length > 0) {
      let item = result.data.works[0];
      setWorkSelected(item);
      // setWorkId(item.workId);
      const url = new URL(window.location.href);
      url.searchParams.set("currentWorkId", item.workId);
      window.history.replaceState({}, "", url.toString());
    } else {
      navigate("/");
    }
  };

  return {
    add,
    removeWork,
    makeWorkTop,
    filterWorks,
  };
};

export default useWork;
